import { h } from 'preact'
import { useState, StateUpdater, useEffect } from 'preact/hooks'
import SingleOption from './single-option'

interface CalculatorCurrencySelectProps {
  isBuyComponent: boolean
  buyCurrency: string
  sellCurrency: string
  handleSetBuyCurrency: StateUpdater<string>
  handleSetSellCurrency: StateUpdater<string>
}

const FIXED_CURRENCY_LIST: string[] = ['PLN', 'EUR', 'USD', 'CHF', 'GBP']

const CalculatorCurrencySelect = ({
  isBuyComponent,
  buyCurrency,
  sellCurrency,
  handleSetBuyCurrency,
  handleSetSellCurrency,
}: CalculatorCurrencySelectProps) => {
  const [isSelectVisible, setSelectVisibility] = useState<boolean>(false)

  const changeSelectVisibiliy = (): void => {
    setSelectVisibility(!isSelectVisible)
  }

  useEffect(() => {
    document
      .querySelector<HTMLDivElement>('.hero-form__main-section')
      .addEventListener('click', (e) => disableOptionsList(e))
  })

  const selectedCurrencyID = isBuyComponent ? buyCurrency : sellCurrency

  const disableOptionsList = (e) => {
    const target = e?.target as HTMLElement
    const $summaryElement = document.querySelector<HTMLDivElement>(`[data-currency-holder=${isBuyComponent}]`)
    if (
      e.target !== $summaryElement &&
      isSelectVisible === true &&
      !target.closest(`[data-currency=${isBuyComponent}]`)
    ) {
      setSelectVisibility(!isSelectVisible)
    }
  }

  const setSelectedCurrency = (selectedOption: string): void => {
    if (isBuyComponent) {
      handleSetBuyCurrency(selectedOption)
      selectedOption === sellCurrency ? handleSetSellCurrency(buyCurrency) : ''
    } else {
      handleSetSellCurrency(selectedOption)
      selectedOption === buyCurrency ? handleSetBuyCurrency(sellCurrency) : ''
    }
  }

  return (
    <div
      className="hero-form__options-holder"
      data-currency-holder={isBuyComponent}
    >
      <div
        className="hero-form__select"
        onClick={changeSelectVisibiliy}
        data-currency={isBuyComponent}
      >
        <p>{selectedCurrencyID}</p>
        <span className="hero-form__select-chevron" />
      </div>
      {isSelectVisible && (
        <div
          className="hero-form__options-list"
          onClick={changeSelectVisibiliy}
        >
          {FIXED_CURRENCY_LIST.map((option) => (
            <SingleOption
              key={option}
              handleSetClickedOption={setSelectedCurrency}
              singleOption={option}
              selectedOption={selectedCurrencyID}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CalculatorCurrencySelect
